/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

export const AICA_SETTINGS_PATH = 'ai-project-settings';
